function Home(){

    return (
        <div  className="App">
         Collection of mini react projects for practice !!!
        </div>
      );

}



export default Home;